class JwtParseError extends Error {
  constructor(jwtToken?: string) {
    super(`JWT Parse Error : ${jwtToken}`);
  }
}

export default JwtParseError;
